var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrupoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.711,
    height: 16,
    viewBox: "0 0 18.711 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_12505",
    "data-name": "Grupo 12505",
    transform: "translate(-67 -412)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_610",
    "data-name": "Trazado 610",
    d: "M13.153,19.558V18.038A3.038,3.038,0,0,0,10.115,15H4.038A3.038,3.038,0,0,0,1,18.038v1.519",
    transform: "translate(67 407.442)",
    fill: "none",
    stroke: "#330072",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_615",
    "data-name": "Elipse 615",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(71 413)",
    fill: "none",
    stroke: "#330072",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_611",
    "data-name": "Trazado 611",
    d: "M22.279,19.589V18.07A3.038,3.038,0,0,0,20,15.13",
    transform: "translate(62.432 407.411)",
    fill: "none",
    stroke: "#330072",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_612",
    "data-name": "Trazado 612",
    d: "M16,3.13a3.038,3.038,0,0,1,0,5.887",
    transform: "translate(63.394 410.296)",
    fill: "none",
    stroke: "#330072",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrupoIcon);
export default __webpack_public_path__ + "static/media/GrupoIcon.1eb814d0184344d3c3e7da2cc1832541.svg";
export { ForwardRef as ReactComponent };